import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'globalFilter'
})
export class GlobalFilterPipe implements PipeTransform {
  transform(value: any, arg: string, ...keys: string[]): any {
    if ((arg === '' || !arg)) return value;

    const result = [];
    for (const item of value) {
      for (const key of keys) {
        if(item[key]){
          if (item[key].toString().toLowerCase().indexOf(arg.toLowerCase()) > -1) {
            result.push(item);
          }
        }
      }
    }
    return result;
  }

}
